import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ae3f88b0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=ae3f88b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3f88b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae3f88b0')) {
      api.createRecord('ae3f88b0', component.options)
    } else {
      api.reload('ae3f88b0', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=ae3f88b0&scoped=true", function () {
      api.rerender('ae3f88b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/detail.vue"
export default component.exports